import template from './creditworthinessOfLoan.html';
import controller from './creditworthinessOfLoan.controller';
import './creditworthinessOfLoan.scss';

let creditworthinessOfLoanComponent = {
  restrict: 'E',
  bindings: {
    loan: '<'
  },
  template,
  controller
};

export default creditworthinessOfLoanComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/creditworthiness/creditworthinessOfLoan/creditworthinessOfLoan.component.js